import { create } from "zustand";
import { createActor } from "xstate";
import rootMachine from "../utils/state-machine/RootMachine";

const rootMachineActor = createActor(rootMachine, { systemId: "root" });
rootMachineActor.start();

const useRootMachineStore = create((set) => ({
  rootMachine: rootMachineActor,

  setRootMachine: (machine) => set({ rootMachine: machine }),

  resetRootMachineStore: () => {
    set({ rootMachine: null });
  },
}));

export default useRootMachineStore;